import React from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from "axios";
import { Container, Grid, TextField, Button, InputLabel, MenuItem, FormControl, Select, ListSubheader, Typography, IconButton, Dialog, DialogActions, DialogContent } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const LineInformation = ({ open, entry, handleClose }) => {

    const closeModal = () => {
        handleClose();
    }

    function formatMonth(monthNo) {
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return monthNames[monthNo - 1];
      }

    return (
        <Dialog open={open} fullWidth onClose={closeModal}>
            {entry && (<DialogContent>
                <Grid container spacing={0}>
                    <Grid item xs={11} md={11}>
                        <Typography color="textSecondary">Vacation Entry</Typography>
                        <br />
                        <table style={{ textAlign: "left" }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: 110 }}><strong>Date</strong></td>
                                    <td>{entry.date.split("-")[2].split("T")[0]} {formatMonth(entry.date.split("-")[1])} {entry.date.split("-")[0]}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: 110 }}><strong>Hours</strong></td>
                                    <td>{entry.quantity}</td>
                                </tr>
                                <tr>
                                    <td><strong>Status</strong></td>
                                    <td>{entry.status}</td>
                                </tr>
                            </tbody>
                        </table>
                    </Grid>
                    <Grid item xs={1} md={1}>
                        <IconButton onClick={closeModal} style={{ padding: "2px", color: "rgb(172, 5, 51)" }}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>

                <hr />
                <Typography color="textSecondary">Description</Typography>
                <p>{entry.description}</p>
            </DialogContent>)}
        </Dialog>
    );
};

export default LineInformation;
